import React, { Component } from 'react';
import styles from './App.module.scss';
import './dx.common.scss';
import './dx.light.scss';
import AppHeader from '../src/components/AppHeader';
import OrderBookPage from '../src/containers/OrderBookPage';
import { Routes as DomRoutes, Route, Navigate } from 'react-router-dom';
import withRouter from './util/customWithRouter';
import getAuth from './api/auth.js';
import queryString from 'query-string';
import PropTypes from 'prop-types';
import appRoutes from './appRoutes';
import { isMobile } from './util/functions';
import { NotificationsContextProvider } from './context/Notifications.context';
import * as Routes from './util/routeConstants';

class App extends Component {
  constructor (props, context) {
    super(props, context);
    this.state = {
      userPool: null,
      userList: null,
      error: null,
      validUser: null,
      pageAccess: {},
      firstAccessPage: null,
      isReady: false
    };
  }

  componentDidMount () {
    const portalAccess = window.localStorage.getItem('portalAccess');
    const token = queryString.parse(this.props.router.location.search).token;
    if (token) {
      getAuth(token)
        .then(data => {
          if (data.validUser && data.validUser.length > 0) {
            // ecn Access , IDQS access
            let ecnAccessArray = data.validUser.filter(function (group) {
              return Routes.ECN_AD_GROUPS.indexOf(group) !== -1;
            });
            let idqsAccessArray = data.validUser.filter(function (group) {
              return Routes.IDQS_AD_GROUPS.indexOf(group) !== -1;
            });

            let nmsAccessArray = data.validUser.filter(function (group) {
              return Routes.NMS_AD_GROUPS.indexOf(group) !== -1;
            });
            const pageAccess = {
              ecn: ecnAccessArray.length > 0,
              idqs: idqsAccessArray.length > 0,
              nms: nmsAccessArray.length > 0
            };

            this.setState({ validUser: data.validUser, pageAccess: pageAccess }, () => {
              this.setState({ isReady: true });
            });
            window.localStorage.setItem('portalAccess', token);
            if (isMobile()) {
              this.props.router.navigate(Routes.RISK_DASHBOARD.path);
            } else {
              if (data.validUser.includes(Routes.ORDER.name)) {
                this.props.router.navigate(Routes.ORDER.path);
              } else if (data.validUser.includes(Routes.TRADE.name)) {
                this.props.router.navigate(Routes.TRADE.path);
              } else if (data.validUser.includes(Routes.TRADE_SUMMARY.name)) {
                this.props.router.navigate(Routes.TRADE_SUMMARY.path);
              } else if (data.validUser.includes(Routes.IDQS_ORDER.name)) {
                this.props.router.navigate(Routes.IDQS_ORDER.path);
              } else if (data.validUser.includes(Routes.IDQS_TRADE.name)) {
                this.props.router.navigate(Routes.IDQS_TRADE.path);
              }
            }
          } else {
            this.redirectLogin();
          }
        })
        .catch(error => {
          console.log(error);
        });
    } else if (portalAccess) {
      getAuth(portalAccess)
        .then(data => {
          if (!data.validUser) {
            this.redirectLogin();
          } else {
            // ecn Access , IDQS access
            let ecnAccessArray = data.validUser.filter(function (group) {
              return Routes.ECN_AD_GROUPS.indexOf(group) !== -1;
            });
            let idqsAccessArray = data.validUser.filter(function (group) {
              return Routes.IDQS_AD_GROUPS.indexOf(group) !== -1;
            });
            let nmsAccessArray = data.validUser.filter(function (group) {
              return Routes.NMS_AD_GROUPS.indexOf(group) !== -1;
            });
            const pageAccess = {
              ecn: ecnAccessArray.length > 0,
              idqs: idqsAccessArray.length > 0,
              nms: nmsAccessArray.length > 0
            };
            let firstAccessPage = '';
            if (isMobile()) {
              firstAccessPage = Routes.RISK_DASHBOARD.path;
            } else {
              if (data.validUser.includes(Routes.ORDER.name)) {
                firstAccessPage = Routes.ORDER.path;
              } else if (data.validUser.includes(Routes.TRADE.name)) {
                firstAccessPage = Routes.TRADE.path;
              } else if (data.validUser.includes(Routes.TRADE_SUMMARY.name)) {
                firstAccessPage = Routes.TRADE_SUMMARY.path;
              } else if (data.validUser.includes(Routes.IDQS_ORDER.name)) {
                firstAccessPage = Routes.IDQS_ORDER.path;
              } else if (data.validUser.includes(Routes.IDQS_TRADE.name)) {
                firstAccessPage = Routes.IDQS_TRADE.path;
              }
            }
            this.setState({ validUser: data.validUser, pageAccess: pageAccess, isReady: true }, () => {
              this.setState({ firstAccessPage: firstAccessPage });
            });
          }
        })
        .catch(error => {
          console.log(error);
          this.redirectLogin();
        });
    } else {
      this.redirectLogin();
    }
  }

  redirectLogin = () => {
    this.setState({ validUser: null }, () => {
      this.setState({ isReady: true }, () => this.props.router.navigate('/login'));
    });
  }

  render () {
    const firstAccessPage = this.state.firstAccessPage;
    let orderBookPageAccess = this.state.validUser ? this.state.validUser.includes(Routes.ORDER_BOOK.name) : false;
    return (
      <div className='dx-swatch-otc-theme'>
        <NotificationsContextProvider>
          {this.state.isReady && this.state.validUser && <AppHeader validUser={this.state.validUser} pageAccess={this.state.pageAccess} />}
          <div className={styles.AppBody}>
            {this.state.isReady && <DomRoutes>
              {firstAccessPage && firstAccessPage !== '' && <Route path='*' element={<Navigate to={firstAccessPage} replace />} />}
              {appRoutes
                .filter(route => route.public)
                .map(({ ...config }, i) => {
                  return <Route key={i} path={config.path} element={config.component} />;
                })
              }

              {appRoutes
                .filter(route => !route.public)
                .map(({ ...config }, i) => {
                // console.log(config)
                  const validUser = this.state.validUser;
                  let componentAccess = validUser ? validUser.includes(config.name) : false;
                  // console.log('componentAccess', config.path, componentAccess)
                  return componentAccess ? <Route key={i} path={config.path} element={config.component} /> : '';
                })
              }

              {orderBookPageAccess && <Route key={'order-book-route'} path={Routes.ORDER_BOOK.path} element={<OrderBookPage validUser={this.state.validUser} />} />}
            </DomRoutes>}
          </div>
        </NotificationsContextProvider>
      </div>
    );
  }
}

export default withRouter(App);

App.propTypes = {
  router: PropTypes.any,
  location: PropTypes.object
};
